import moment from 'moment'
import { IMeetupPlace } from 'static/interfaces'

export const emptyValue = (value: number | string | null | undefined) => {
  if (value === null || value === undefined || value === '') {
    return '-'
  }
  return value
}

export const formatDateTime = (value: string | null | undefined) =>
  value ? moment(value).format('YYYY-MM-DD HH:mm') : '-'

export const getPaymentStatusBadgeType = (paymentStatus: string) => {
  if (paymentStatus === 'paid') {
    return 'success'
  }

  if (paymentStatus === 'unpaid') {
    return 'caution'
  }

  return 'info'
}

export const getMeetupPlaceLabel = (meetupPlace: IMeetupPlace) =>
  `${meetupPlace.name_en} | ${meetupPlace.name_ja}`
